import { type RefObject, useEffect, useRef } from "react";
import { prefersReducedMotion } from "../utils/reducedMotion";

/**
 * Scrolls an element into view the first time `ready` is true — e.g. a panel the user is being returned to,
 * once its content has rendered and has its height. Once only: re-renders never pull the page back to it.
 * Smooth unless the user asked for reduced motion.
 */
export const useScrollIntoViewOnce = (ref: RefObject<HTMLElement | null>, ready: boolean): void => {
	const done = useRef(false);
	useEffect(() => {
		if (!ready || done.current || ref.current === null) return;
		done.current = true;
		ref.current.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "nearest" });
	}, [ready, ref]);
};
